var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandStrapiStyleBlack = function SvgBrandStrapiStyleBlack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandStrapiStyleBlack__clip0_3953_119415)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M1.218 1.218C0 2.437 0 4.398 0 8.32v7.36c0 3.922 0 5.883 1.219 7.102C2.437 24 4.398 24 8.32 24h7.36c3.922 0 5.883 0 7.102-1.218C24 21.563 24 19.602 24 15.68V8.32c0-3.922 0-5.883-1.218-7.102C21.563 0 19.602 0 15.68 0H8.32C4.398 0 2.437 0 1.218 1.218M8.64 15.52h3.96v3.927a.08.08 0 0 0 .137.056l3.983-3.983V7.44a.16.16 0 0 0-.16-.16H8.48l-3.983 3.984a.08.08 0 0 0 .056.136H8.48v3.96a.16.16 0 0 0 .16.16",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandStrapiStyleBlack__clip0_3953_119415"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandStrapiStyleBlack);
export { ForwardRef as ReactComponent };